import React, { memo, ReactNode } from "react";
import { Text, HStack, Box } from "@chakra-ui/react";
import colors from "app/colors";

interface IInfoRowProps {
  icon: ReactNode;
  content: string | ReactNode;
  color?: string;
}

const InfoRow = ({ icon, content, color = colors.gray50 }: IInfoRowProps) => {
  if (typeof content === "string") {
    return (
      <HStack spacing={4} w="full">
        {icon}
        <Text color={color} fontWeight={600} fontSize={16} w="full">
          {content}
        </Text>
      </HStack>
    );
  }

  return (
    <HStack spacing={4} w="full" alignItems="flex-start">
      <Box>{icon}</Box>
      {content}
    </HStack>
  );
};

export default memo(InfoRow);
